<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-input/services' }">安全服务</el-breadcrumb-item>
            <el-breadcrumb-item>{{countryTitle}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="headContainer">
          <el-backtop target=".headContainer">
            <i class="el-icon-caret-top"></i>
          </el-backtop>
          <el-form ref="formData" :model="formData" label-width="120px">
            <el-form-item label="服务名称">
              <el-input v-model="formData.service_name" placeholder="请输入服务名称" style="width: 240px;"></el-input>
            </el-form-item>

            <el-form-item label="启用/禁用">
              <el-switch
                v-model="formData.status"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>

            <el-form-item label="介绍">
              <quill-editor v-model="formData.intro"
                ref="myQuillEditor"
                class="editer"
                :options="editorOption" @ready="onEditorReady($event)">
              </quill-editor>
            </el-form-item>

            <el-form-item label="联系QQ">
              <el-input v-model="formData.qq" placeholder="请输入QQ" style="width: 240px;"></el-input>
            </el-form-item>

            <el-form-item label="封面图片">
              <img v-if="formData.cover" :src="formData.cover" style="width: 120px;height: 120px"/>
              <uploadFlie
                v-if="!formData.cover"
                ref="nationalFlag"
                imageType=".jpg,.jpeg,.png"
                :imageData="imageData"
                :imageUrl="imageUrl"
                :fileList="fileList1"
              ></uploadFlie>
              <el-button v-if="formData.cover" type="primary" @click="formData.cover='' ">编辑</el-button>
            </el-form-item>

            <el-form-item label="联系微信二维码">
              <img v-if="formData.qrcode" :src="formData.qrcode" style="width: 120px;height: 120px"/>
              <uploadFlie
                v-if="!formData.qrcode"
                ref="nationalEmblem"
                imageType=".jpg,.jpeg,.png"
                :imageData="imageData2"
                :imageUrl="imageUrl"
                :fileList="fileList2"
              ></uploadFlie>
              <el-button v-if="formData.qrcode" type="primary" @click="formData.qrcode='' ">编辑</el-button>
            </el-form-item>

            <el-form-item label="联系电话">
              <el-input v-model="formData.telephone" placeholder="请输入联系电话" style="width: 240px;"></el-input>
            </el-form-item>

            <el-form-item label="联系邮箱">
              <el-input v-model="formData.email" placeholder="请输入联系邮箱" style="width: 240px;"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <!-- <el-button type="primary" v-if="submit" @click="newSubmit">提交并新建</el-button> -->
              <el-button @click="goToCountryBase">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor' //调用编辑器
import uploadFlie from "@/components/unloadFile/index";
// import timeZoneSelect from "./time_zone";
import api from "../api";
import tokenService from "@/utils/services/token_service"

export default {
  components: { uploadFlie,quillEditor },
  data() {
    return {
      countryTitle: "新增条目", //标题
      editorOption: {
        placeholder: '请输入正文'
      },
      imageData: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "1",
        dir: "secretservice"
      },
      imageData2: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "1",
        dir: "qrcode"
      },
      imageUrl: "http://yjapi.ciwei.com/api.php?do=admin_file_upload", //写死参数
      currentFile: null, //当前文件
      addressSelectData: null, //地址控件选择
      submit: true, //提交状态
      newConstruction: false, //返回状态
      fileList1: [], //文件列表
      fileList2: [], //文件列表
      ruleForm: {
        dialogImageUrl: "" //预览地址
      },
      formData: {
        //参数
        qrcode: '',
        cover: ''
      }
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  created() {

    //如果有countryId 则是修改状态
    if (this.$route.query.countryId) {
      this.infoCommonData()
      this.countryTitle = "修改条目";
      this.submit = false;
    }
  },
  methods: {
    // infoCommonData
    infoCommonData() {
      let data = {
        id: this.$route.query.countryId,
      };
      api
        .servicesInfo(data)
        .then(res => {
          this.formData = res.info
          this.fileList1.push({ url: this.formData.cover})
          this.fileList2.push({ url: this.formData.qrcode})
        })
        .catch(err => {
          this.$message(err);
        });
    },
    // 提交并新建表单
    newSubmit() {
      let data = this.formData;
      if(data.cover == "") {
        data.cover = this.$refs.nationalFlag.UploadImageUrl;
      }
      if(data.qrcode == "") {
        data.qrcode = this.$refs.nationalEmblem.UploadImageUrl;
      }


      // 编辑状态
      if (this.$route.query.countryId) {
        data.id = this.$route.query.countryId; //添加国家id
        api
          .servicesEdit(data)
          .then(res => {
            if (res.error_code == 0) {

              this.$message({
                message: "修改成功！",
                type: "success"
              });

              this.formData = {};
              this.submit = true;
              if (this.newConstruction) {
                //修改成功 跳转原页面
                this.goToCountryBase();
                this.newConstruction = false;
              }
            }
          })
          .catch(err => {
            this.$message.error(err.error_message);
          });
      } else {
        // 新增参数
        api
          .servicesAdd(data)
          .then(res => {
            if (res.error_code == 0) {
              this.$message({
                message: "新建成功！",
                type: "success"
              });
              
              this.formData = {};
              this.submit = true;
              if (this.newConstruction) {
                this.goToCountryBase();
                this.newConstruction = false;
              }
            }
          })
          .catch(err => {
             this.$message.error(err.error_message);
          });
      }
    },

    // 提交表单
    onSubmit() {
      this.newConstruction = true;
      this.newSubmit();
    },

    // 取消跳转原页面
    goToCountryBase() {
      this.$router.push({
        name: "services"
      });
    }
  }
};
</script>

<style>
  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  .ql-editor{
      height:200px;
    }
</style>